import type {
    ITcohV2RequestAndProcedureIndicatieDataValidated,
    ITcohV2RequestAndProcedureMedicatieDataValidated,
} from '../validation/customControls/cardiology/holterConsult/cardiology';

export function decodeHolterIndications(customControlData: {
    indicatie: ITcohV2RequestAndProcedureIndicatieDataValidated;
}) {
    const result = [];
    if (customControlData.indicatie.dyspnoeDeffort) {
        result.push("Dyspnoe d'effort");
    }
    if (customControlData.indicatie.controleTherapie) {
        result.push('Controle therapie');
    }
    if (customControlData.indicatie.hartfalen) {
        result.push('Hartfalen');
    }
    if (customControlData.indicatie.ritmeGeleidingsstoornissen) {
        result.push('Ritme / geleidingsstoornissen');
    }
    if (customControlData.indicatie.decompensatioCordis) {
        result.push('Decompensatio cordis');
    }
    if (customControlData.indicatie.duizeling) {
        result.push('Duizeling / collapsneigingen / wegraking');
    }
    if (customControlData.indicatie.ventrikelHypertrofie) {
        result.push('Ventrikel hypertrofie');
    }
    if (customControlData.indicatie.hartkloppingen) {
        result.push('Hartkloppingen / overslag');
    }
    if (customControlData.indicatie.kleplijden) {
        result.push('Kleplijden');
    }
    if (customControlData.indicatie.verdenkingIschemie) {
        result.push('Verdenking ischemie / infarct');
    }
    if (customControlData.indicatie.hypertensie) {
        result.push('Hypertensie');
    }
    if (customControlData.indicatie.typischeAngina) {
        result.push('Typische angina pectoris');
    }
    if (customControlData.indicatie.algemeenOnderzoek) {
        result.push('Algemeen onderzoek');
    }
    if (customControlData.indicatie.atypischeAngina) {
        result.push('Atypische angina pectoris');
    }
    if (customControlData.indicatie.geruststelling) {
        result.push('Geruststelling');
    }
    if (customControlData.indicatie.andersText) {
        result.push(customControlData.indicatie.andersText);
    }

    return result;
}

export function decodeHolterMedications(customControlData: {
    medicatie: ITcohV2RequestAndProcedureMedicatieDataValidated;
}) {
    const result = [];
    if (customControlData.medicatie.geenMedicatie) {
        result.push('Geen medicatie');
    }
    if (customControlData.medicatie.antiStolling) {
        result.push('Antistolling');
    }
    if (customControlData.medicatie.geenCardialeMedicatie) {
        result.push('Geen cardiale medicatie');
    }
    if (customControlData.medicatie.aceRemmer) {
        result.push('Ace-remmer');
    }
    if (customControlData.medicatie.antiAritmica) {
        result.push('Antiaritmica');
    }
    if (customControlData.medicatie.calciumantagonist) {
        result.push('Calciumantagonist');
    }
    if (customControlData.medicatie.digitalis) {
        result.push('Digitalis');
    }
    if (customControlData.medicatie.nitraten) {
        result.push('Nitraten');
    }
    if (customControlData.medicatie.betaBlokker) {
        result.push('Bètablokker');
    }
    if (customControlData.medicatie.antiHypertensiva) {
        result.push('Antihypertensiva');
    }
    if (customControlData.medicatie.diuretica) {
        result.push('Diuretica');
    }
    if (customControlData.medicatie.andersText) {
        result.push(customControlData.medicatie.andersText);
    }

    return result;
}
